import update from 'immutability-helper';
import { handleActions } from 'redux-actions';

import {
  LOAD_STAFF_PRACTITIONER_LIST,
  LOAD_STAFF_PRACTITIONER_LIST_SUCCESS,
  LOAD_STAFF_PRACTITIONER_LIST_ERROR,
} from '../type';
import { initialState } from './initialize';

const practitionerReducer = handleActions(
  new Map([
    [
      LOAD_STAFF_PRACTITIONER_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            loadPractitionersLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_STAFF_PRACTITIONER_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadPractitionersLoading: { $set: false },
          },
          practitioners: { $set: action.payload },
        });
      },
    ],
    [
      LOAD_STAFF_PRACTITIONER_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            loadPractitionersLoading: { $set: false },
          },
          practitioners: { $set: [] },
        });
      },
    ],
  ]),
  initialState,
);

export default practitionerReducer;
